/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-checkin-component.ts
 *
 * Created by randysorensen on 1/9/18.
 */

'use strict';


//
// This is the tab controller and gets its name from the sidebar
// item. The "BatchCheckinController" is specific to the check-in
// tab.
//

function PackageCheckinController(
    this: JS5Object,

    // external deps
    _: JS5Object,

    // internal deps
    BreadcrumbService: JS5Object,
    ModalService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.onTabSelect = (name: string): void => {
        switch (name) {
            case 'checkin':
                break;

            case 'checkedOut':
                break;

            default:
                console.warn(`PackageCheckinController.onTabSelect(): no such tab '${name}'`);
                break;
        }
    };

    this.onTabDeselect = (name: string, $event: JS5Object): void => {
        switch (name) {
            case 'checkin':
                break;

            case 'checkedOut':
                break;

            default:
                console.warn(`PackageCheckinController.onTabDeselect(): no such tab '${name}'`);
                break;
        }
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = (): void => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Package Check-in',
            location: '/dashboard/checkin',
        });
    }

}


angular
.module('prism-ui.dashboard.checkin')
.component('packageCheckin', {
    controller: PackageCheckinController,
    templateUrl: 'dashboard/packageCheckin/package-checkin-template.html',
    bindings: {
    }
});
